import { merge } from "lodash-es";
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jul 15 2024
 **/

/**
 * @link https://docs.google.com/spreadsheets/d/1Zks_T7K-21O_khH-ZqQ991d2xu0aXI6iQlrlOKFD9Ok/edit?gid=1765074270#gid=1765074270
 * @link https://docs.google.com/spreadsheets/d/14LcfbuJipbshqMkG5IO2cROEET9rMZfTjPRRBfIkgwo/edit?gid=1514673389#gid=1514673389
 * @description 알람 로그 메시지 타입
 */

export const AlarmLogMessageNormal = {
	GROUP_JOIN_REQUEST: "groupJoinRequest",
	GROUP_ACCEPT_JOIN_REQUEST: "groupAcceptJoinRequest",
	GROUP_REJECT_JOIN_REQUEST: "groupRejectJoinRequest",
	GROUP_USER_DELETED_BY_ADMIN: "groupUserDeletedByAdmin",
	GROUP_ACCEPT_DELETE_REQUEST: "groupAcceptDeleteRequest",
	GROUP_INVITED: "groupInvited",
	GROUP_ADMIN_ASSIGNED: "groupAdminAssigned",
	GROUP_INVITE_PROCESSED: "groupInviteProcessed",
	GROUP_INVITE_PROCESS: "groupInviteProcess",
	GROUP_JOINED: "groupJoined",
	SPACE_JOIN_REQUEST: "spaceJoinRequest",
	SPACE_JOIN_REQUEST_CANCEL: "spaceJoinRequestCancel",
	SPACE_ACCEPT_JOIN_REQUEST: "spaceAcceptJoinRequest",
	SPACE_REJECT_JOIN_REQUEST: "spaceRejectJoinRequest",
	SPACE_DELETED: "spaceDeleted",
	SPACE_INFO_UPDATED: "spaceInfoUpdated",
	SPACE_INVITED: "spaceInvited",
	SPACE_USER_DELETED_BY_ADMIN: "spaceUserDeletedByAdmin",
	SPACE_INVITE_PROCESSED: "spaceInviteProcessed",
	SPACE_JOINED: "spaceJoined",
	SPACE_PARTICIPATED: "spaceParticipated",
	SPACE_ADMIN_ASSIGNED: "spaceAdminAssigned",
	FRIEND_REQUESTED: "friendRequested",
	GUEST_BOOK_POSTED: "guestBookPosted",
	MY_DESK_KNOCKED: "myDeskKnocked",
	OPEN_WORLD_BLOCKED_USER_PARTICIPATED: "openWorldBlockedUserParticipated",
	HANGUP_NO_RESPONSE_CALL: "hangupNoResponseCall",
	KNOCK: "knock",
	MEETING_SCHEDULE_INVITE: "meetingScheduleInvite",
	MEETING_CONFERENCE_INVITE: "meetingConferenceInvite",
	MEETING_SCHEDULE_REMIND: "meetingScheduleRemind"
} as const;

export const AlarmLogMessageNotice = {
	NOTICE_NOTIFY: "noticeNotify"
} as const;

export const AlarmLogMessage = merge(AlarmLogMessageNormal, AlarmLogMessageNotice);

export type AlarmLogMessageValue = (typeof AlarmLogMessage)[keyof typeof AlarmLogMessage];

export const AlarmCategory = {
	NORMAL: "NORMAL",
	NOTICE: "NOTICE"
};

export type AlarmCategoryType = keyof typeof AlarmCategory;
